import { create } from "zustand";
import type { CompanySearchRequest } from "../types/company.types";

const DEFAULT_SEARCH: CompanySearchRequest = {
  page: 1,
  pageSize: 20,
  searchStr: "",
  isActive: null,
};

interface CompanyStore {
  searchStr: string;
  searchParams: CompanySearchRequest;
  selectedGuid: string | null;
  drawerOpen: boolean;

  setSearchStr: (str: string) => void;
  setIsActive: (val: boolean | null) => void;
  setPage: (page: number) => void;
  search: () => void;
  reset: () => void;

  openDrawerForAdd: () => void;
  openDrawerForEdit: (guid: string) => void;
  closeDrawer: () => void;
}

export const useCompanyStore = create<CompanyStore>((set) => ({
  searchStr: "",
  searchParams: { ...DEFAULT_SEARCH },
  selectedGuid: null,
  drawerOpen: false,

  setSearchStr: (searchStr) => set({ searchStr }),
  setIsActive: (isActive) =>
    set((s) => ({ searchParams: { ...s.searchParams, isActive, page: 1 } })),
  setPage: (page) =>
    set((s) => ({ searchParams: { ...s.searchParams, page } })),
  search: () =>
    set((s) => ({
      searchParams: { ...s.searchParams, searchStr: s.searchStr, page: 1 },
    })),
  reset: () => set({ searchStr: "", searchParams: { ...DEFAULT_SEARCH } }),

  openDrawerForAdd: () => set({ selectedGuid: null, drawerOpen: true }),
  openDrawerForEdit: (guid) => set({ selectedGuid: guid, drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false, selectedGuid: null }),
}));
